import * as Yup from 'yup';

// Accept both 9-digit Wishmaker ID or alphanumeric username (min 3 chars)
const wmIdRegx = /^(\d{9}|[a-zA-Z0-9]{3,})$/;

export const validateWmId = Yup.string()
  .matches(wmIdRegx, 'login_form_wm_id_not_matching')
  .required('login_form_wm_id_required');

export default Yup.object().shape({
  wm_id: validateWmId,
  password: Yup.string().required('login_form_password_required'),
});
